import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

export const StatColumn: React.FC<{ label: string; value: number; adjustedValue?: number; onClick?: (e: React.MouseEvent<HTMLElement>) => void }> = ({
  label,
  value,
  adjustedValue,
  onClick
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: 0.5,
      py: 1,
    }}
  >
    <Typography variant="caption" color="textSecondary">
      {label}
    </Typography>
    <Chip
      label={`${adjustedValue ?? value}${adjustedValue !== value && adjustedValue !== undefined ? '/' + value: ''}`}
      onClick={onClick}
      sx={{
        fontWeight: 700,
        fontSize: '1rem,',
        cursor: onClick ? 'pointer' : 'default',
        backgroundColor: `${adjustedValue !== undefined && adjustedValue !== value ? 'white' : 'transparent'}`
      }}
    />
  </Box>
);
